export class Qualification {
  id: number;
  slug: string;
  name: string;

  constructor(id: number, slug: string, name: string) {
    this.id = id;
    this.slug = slug;
    this.name = name;
  }

  static factory(qualificationAPI: QualificationAPI): Qualification {
    return new Qualification(qualificationAPI.id, qualificationAPI.slug, qualificationAPI.name);
  }
}

export type QualificationAPI = {
  id: number;
  slug: string;
  name: string;
};
